import { useEffect, useState } from "react";
import { useAuth } from "../lib/auth";

export default function SincronizacionPage() {
  const { token } = useAuth();
  const [status, setStatus] = useState<any>(null);
  const headers = { Authorization: `Bearer ${token}`, "Content-Type": "application/json" };

  useEffect(() => {
    fetch("/api/v1/health", { headers })
      .then(r => r.json())
      .then(setStatus)
      .catch(() => setStatus({ status: "error" }));
  }, []);

  return (
    <div style={{ padding: 24 }}>
      <h2 style={{ marginBottom: 16 }}>Sincronización</h2>
      <p>Estado del servicio: <strong>{status?.status ?? "cargando..."}</strong></p>
    </div>
  );
}
